
import type { PropType, SetupContext } from 'vue'
import type { QueryRankingElementActionConfig } from '../../composables/use-query-ranking-element-actions-config'
import { QueryRankingElementRankingAction } from '@empathyco/playboard-core-domain'
import { computed, defineComponent } from 'vue'
import { EpbButton } from '../../components/shared/epb-button'
import { useQueryRankingElementActionsConfig } from '../../composables/use-query-ranking-element-actions-config'

type QueryRankingActionButton = QueryRankingElementActionConfig & {
  selected: boolean
  disabled: boolean
}

export default defineComponent({
  name: 'QueryRankingActionButtons',
  components: {
    EpbButton,
  },
  props: {
    actions: {
      type: Array as PropType<Array<QueryRankingElementActionConfig['action']>>,
      required: false,
      default: () => [
        QueryRankingElementRankingAction.BOOST,
        QueryRankingElementRankingAction.BURY,
      ],
    },
    selected: {
      type: Array as PropType<Array<QueryRankingElementActionConfig['action']>>,
      required: false,
      default: () => [],
    },
    disabled: {
      type: [Array, Boolean] as PropType<
        Array<QueryRankingElementActionConfig['action']> | boolean
      >,
      required: false,
      default: undefined,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click'],
  setup(props, ctx: SetupContext) {
    const { getActionConfig } = useQueryRankingElementActionsConfig()

    const buttons = computed<Array<QueryRankingActionButton>>(() => {
      return props.actions.map(action => {
        const selected = props.selected.includes(action)
        const config = getActionConfig(action, { negativeVariant: selected })
        return {
          ...config,
          icon: props.showIcon ? config.icon : undefined,
          selected,
          disabled:
            (Array.isArray(props.disabled) && props.disabled.includes(action)) ||
            (typeof props.disabled === 'boolean' && props.disabled),
        }
      })
    })

    const onClick = (
      action: QueryRankingElementActionConfig['action'],
      isSelected: boolean,
    ): void => {
      const selected = !isSelected

      ctx.emit('click', { action, selected })
    }

    return {
      baseClass: 'epb-actions-buttons-query-ranking',
      buttons,
      onClick,
    }
  },
})
